<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
    :header-cell-style="headerCellStyle"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'detail',
                code: row.orderGoodsSpecCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-edit tool-btn" @click="editGoods(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.orderGoodsSpecCode)"
          ></i>
        </el-tooltip>
      </div>
    </template>
    <template v-slot:defaultImageUrl="{ row }">
      <el-image
        :src="
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg'
        "
        style="width:100px; height:66px"
        :preview-src-list="[
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg',
        ]"
      >
        <div slot="error" class="image-slot">
          <img
            src="/image/static/img/nopic.jpg"
            style="width: 100px; height: 66px"
          />
        </div>
      </el-image>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    showDefaultImage: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    },
    del(orderGoodsSpecCode) {
      this.$emit('batchDel', [orderGoodsSpecCode])
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }
      if (type === 'code') {
        return data.map((row) => {
          return row.orderGoodsSpecCode
        })
      }
      return data
    },
    async editGoods({ orderGoodsCode, orderGoodsSpecCode }) {
      const res = await this.$api
        .orderGoodsModifyAllowApi(orderGoodsCode)
        .catch(() => null)
      const modifyAllow = res?.body || false

      this.$emit('openDetailDialog', {
        type: modifyAllow ? 'edit' : 'detail',
        code: orderGoodsSpecCode,
      })
    },
  },
}
</script>
